/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} On_The_WaterInputs */

const en_on_the_water = /** @type {(inputs: On_The_WaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On The Water`)
};

const es_on_the_water = /** @type {(inputs: On_The_WaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En transito maritimo`)
};

/**
* | output |
* | --- |
* | "On The Water" |
*
* @param {On_The_WaterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const on_the_water = /** @type {((inputs?: On_The_WaterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<On_The_WaterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_on_the_water(inputs)
	return es_on_the_water(inputs)
});